import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getCompletionnDetail = async (submissionId) => {
  const { data } = await API.get(
    `${GET_ENDPOINTS.COMPLETION_DETAIL}${submissionId}`,
  );
  return data;
};

const useCompletionDetail = (submissionId) =>
  useQuery([QUERY_KEYS.COMPLETION_DETAILS, submissionId], () =>
    submissionId ? getCompletionnDetail(submissionId) : null,
  );

export default useCompletionDetail;
